import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from 'sonner';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HolidayBanner from "@/components/HolidayBanner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/services/ServiceDetail";
import Education from "@/pages/Education";
import ArticleReader from "@/pages/ArticleReader";
import Resources from "@/pages/Resources";
import Appointment from "@/pages/Appointment";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Admin from "@/pages/Admin";
import Grievance from "@/pages/Grievance";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminGate from "@/components/AdminGate";
import AuthCallback from "@/components/AuthCallback";

axios.defaults.withCredentials = true;

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/education" element={<Education />} />
      <Route path="/education/:slug" element={<ArticleReader />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/appointment" element={<Appointment />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
      <Route path="/disclosures" element={<Grievance />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <HolidayBanner />
        <Toaster position="top-right" richColors />
        <AppRoutes />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;